import {
  Box, Button,
  Icon,
  Input,
  InputGroup,
  InputRightElement,
  Tooltip,
} from '@chakra-ui/react';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { FaUpload } from 'react-icons/fa';
import { FaDeleteLeft } from "react-icons/fa6";

const FileInput = ({
  initialFile,
  onSelectFiles,
  allowedFileTypes,
  ...props
}) => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedFileName, setSelectedFileName] = useState('');

  useEffect(() => {
    setSelectedFiles(initialFile ? [initialFile] : []);
  }, [initialFile]);

  useEffect(() => {
    setSelectedFileName(getFileName(selectedFiles));
  }, [selectedFiles]);

  const onDrop = (acceptedFiles) => {
    setSelectedFiles(acceptedFiles);
    onSelectFiles(acceptedFiles);
  };

  let dropzoneProps = {
    noClick: true,
    noKeyboard: true,
    multiple: false,
    onDrop,
  };
  if (allowedFileTypes) {
    dropzoneProps.accept = {};
    allowedFileTypes.forEach((fileType) => {
      dropzoneProps.accept[fileType] = [];
    });
  }

  const { getRootProps, getInputProps, open } = useDropzone(dropzoneProps);

  function cleanSelectedFiles() {
    setSelectedFiles([])
    onSelectFiles([]);
    setSelectedFileName('');
  }

  function getFileName(selectedFiles) {
    let r = '';
    if (selectedFiles) {
      r = selectedFiles[0]?.name
    }
    // console.log("getFileName", r);
    return r
  }
  return (
    <Box {...getRootProps()}>
      <input {...getInputProps()} />
      <InputGroup>
        <Tooltip label={selectedFileName}>
          <Input
            {...props}
            w={props.w || 200}
            onClick={open}
            pr={10}
            placeholder={props.placeholder?props.placeholder:'Select File'}
            value={selectedFileName ?? ''}
            readOnly
            // onChange={() => {}}
          />
        </Tooltip>
        <InputRightElement>
          <Button
          size="sm"
          onClick={cleanSelectedFiles}
          isDisabled={props.disabled || selectedFiles.length === 0}
          >
            <Icon as={FaDeleteLeft} />
          </Button>
        </InputRightElement>
      </InputGroup>
    </Box>
  );
};

FileInput.propTypes = {
  initialFile: PropTypes.object,
  onSelectFiles: PropTypes.func.isRequired,
  allowedFileTypes: PropTypes.arrayOf(PropTypes.string),
};

export default FileInput;
